import { AITickets } from "modules/aiTickets";

const AITicketsPage = () => {
  return <AITickets />;
};

export default AITicketsPage;
